export const zervantFontOptions = {
  arvo: 'Arvo',
  baskervville: 'Baskervville',
  bitter: 'Bitter',
  fahkwang: 'Fahkwang',
  georama: 'Georama',
  ibmPlexSansCondensed: 'IBM Plex Sans Condensed',
  krub: 'Krub',
  libreBaskerville: 'Libre Baskerville',
  openSans: 'Open Sans',
  playfair: 'Playfair',
  poppins: 'Poppins',
  quicksand: 'Quicksand',
  roboto: 'Roboto',
  robotoCondensed: 'Roboto Condensed',
  robotoMono: 'Roboto Mono',
  rokkitt: 'Rokkitt',
  sen: 'Sen',
  solway: 'Solway',
  spaceMono: 'Space Mono',
  varelaRound: 'Varela Round',
  volkhov: 'Volkhov',
  workSans: 'Work Sans',
  zillaSlab: 'Zilla Slab',
}
